import React, { memo, useCallback, useState } from "react";
import { Button, Modal } from "antd";

import { useClient } from "../../../hooks/ClientProvider";
import * as S from "../../../pages/home/modals/styles";
import api from "../../../services/api";
import { notifyError, notifySucces } from "../../../utils/notifications";
import AntInput from "../../AntInput";

const { confirm } = Modal;

function ChangeLimitCardModal({
  isModalVisible,
  closeModal,
  reloadCards = null,
}) {
  const [alterLimit, setAlterLimit] = useState(true);
  const [valueMask, setValueMask] = useState("");
  const [newLimit, setNewLimit] = useState("");
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const { client, cardFinancial, refreshCardFinancial, refreshClientV2 } = useClient();

  const limitePrincipal = Number(cardFinancial?.limitePrincipal) || 0;

  const handleCancel = useCallback(() => {
    setValueMask("");
    setNewLimit("");
    setAlterLimit(true);
    closeModal();
  }, [closeModal]);

  const changeNewLimit = useCallback((value) => {
    const cleanValue = value.replace(/[^0-9]/g, "");
    if (cleanValue) {
      const options = { minimumFractionDigits: 2 };
      const result = new Intl.NumberFormat("pt-BR", options).format(
        parseFloat(cleanValue) / 100
      );
      setValueMask(`R$ ${result}`);
      setNewLimit(
        result.replace(/[\.,]/g, (match) =>
          match === "." ? "" : match === "," ? "." : match
        )
      );
    } else {
      setValueMask("");
      setNewLimit("");
      setAlterLimit(true);
    }
  }, []);

  const handleChangeLimit = useCallback(
    async (limit, limiteAtual) => {
      const numericLimit = Number(limit);
      if (isNaN(numericLimit) || numericLimit <= 0) {
        notifyError("Favor inserir um valor numérico válido");
        return;
      }

      const limitTruncated = Math.trunc(numericLimit);

      try {
        setLoadingSubmit(true);

        await api.patch("card_limit", {
          client_id: client?.client?.id,
          limiteAplicado: limitTruncated,
          limiteProxPeriodo: limitTruncated,
          limiteAnterior: limiteAtual,
        });

        notifySucces(
          `Limite alterado para R$ ${limitTruncated},00 com sucesso`
        );

        if (refreshCardFinancial) {
          await refreshCardFinancial();
        }

        if (typeof reloadCards === "function") {
          reloadCards();
        }

        if (refreshClientV2) {
          await refreshClientV2();
        }
      } catch (error) {
        notifyError("Falha ao atualizar limite");
      } finally {
        setLoadingSubmit(false);
        setValueMask("");
        setNewLimit("");
        setAlterLimit(true);
        closeModal();
      }
    },
    [client?.client?.id, closeModal, refreshCardFinancial, refreshClientV2, reloadCards]
  );

  const handleAlterLimit = useCallback((limit, limiteAtual) => {
    const parsedLimit = parseInt(limit, 10);
    if (!limit || parsedLimit === limiteAtual || parsedLimit <= 0) {
      setAlterLimit(true);
    } else if (Math.trunc(Number(limit)) > 999999) {
      setAlterLimit(true);
      notifyError("Não é possível ter um limite com mais de 6 dígitos");
    } else {
      setAlterLimit(false);
    }
  }, []);

  const showConfirm = (targetLimit, currentLimit) => {
    confirm({
      title: `Alterar limite para R$ ${Number(targetLimit)
        .toFixed(2)
        .replace(".", ",")}?`,
      onOk() {
        handleChangeLimit(targetLimit, currentLimit);
      },
      onCancel() {
        setValueMask("");
        setNewLimit("");
        setAlterLimit(true);
        closeModal();
      },
    });
  };

  return (
    <Modal
      title="Alterar limite do cartão"
      visible={isModalVisible}
      onCancel={handleCancel}
      footer={null}
    >
      <b>
        <span>Limite atual</span>
      </b>
      <AntInput
        type="text"
        readonly="readonly"
        value={`R$ ${limitePrincipal.toFixed(2).replace(".", ",")}`}
      />
      <p />
      <b>Valor do novo limite</b>
      <AntInput
        type="text"
        placeholder=" R$ 1.000,00"
        value={valueMask}
        onChange={(e) => changeNewLimit(e.target.value)}
        onKeyUp={() => {
          handleAlterLimit(newLimit, limitePrincipal);
        }}
      />
      <S.ModalRow>
        <S.ButtonAtualizar>
          <Button
            type="primary"
            onClick={() => showConfirm(newLimit, limitePrincipal)}
            disabled={alterLimit || loadingSubmit}
            loading={loadingSubmit}
          >
            Atualizar
          </Button>
        </S.ButtonAtualizar>
      </S.ModalRow>
    </Modal>
  );
}

export default memo(ChangeLimitCardModal);